import "../../_generated_templates.js";
window.AssessmentBuilder ??= {};
window.AssessmentBuilder.Views ??= {};

AssessmentBuilder.Views.Intro = class Intro extends Backbone.View {
  constructor() {
    super(...arguments);
    this.render = this.render.bind(this);
    this.select = this.select.bind(this);
    this.unselect = this.unselect.bind(this);
  }

  render() {
    this.$el.html(this.template(this.model.attributes));
    return this;
  }

  // HELPER FUNCTIONS

  select() {
    const changed = !this.selected;
    this.selected = true;
    this.$el.find(".submitter-info").addClass(this.selectedCss);

    return changed;
  }

  unselect() {
    const changed = this.selected;
    this.selected = false;
    this.$el.find(".submitter-info").removeClass(this.selectedCss);

    return changed;
  }

  // EVENT HANDLERS

  triggerIntroClicked() {
    return this.$el.trigger(AssessmentBuilder.Events.Intro.clicked);
  }
};
AssessmentBuilder.Views.Intro.prototype.tagName = "intro-element";
AssessmentBuilder.Views.Intro.prototype.selectedCss = "selected";
AssessmentBuilder.Views.Intro.prototype.template = _.template(AssessmentBuilder.Templates.Intro.intro);
AssessmentBuilder.Views.Intro.prototype.events = { "click .intro": "triggerIntroClicked" };
